/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scale a PCR master mix to any number of reactions. Set your per-reaction volumes, the reaction count and an overage for pipetting loss to get the total of each reagent.`)
};

const es_pcr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escala un master mix de PCR a cualquier número de reacciones. Define tus volúmenes por reacción, el número de reacciones y un exceso para compensar pérdidas de pipeteo, y obtén el total de cada reactivo.`)
};

const de_pcr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skalieren Sie einen PCR-Mastermix auf beliebig viele Reaktionen. Geben Sie die Volumina pro Reaktion, die Reaktionsanzahl und einen Überschuss für Pipettierverluste ein, um das Gesamtvolumen jedes Reagenzes zu erhalten.`)
};

const nl_pcr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schaal een PCR-mastermix naar elk aantal reacties. Stel uw volumes per reactie, het aantal reacties en een overmaat voor pipetteerverlies in om het totaal van elk reagens te berekenen.`)
};

const fr_pcr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adaptez un mix maître PCR à n'importe quel nombre de réactions. Définissez vos volumes par réaction, le nombre de réactions et une marge pour les pertes de pipetage afin d'obtenir le total de chaque réactif.`)
};

const it_pcr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scala un master mix PCR per qualsiasi numero di reazioni. Imposta i volumi per reazione, il numero di reazioni e un margine per le perdite di pipettaggio per ottenere il totale di ogni reagente.`)
};

const pt_br2_pcr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione um master mix de PCR para qualquer número de reações. Defina os volumes por reação, o número de reações e um excedente para perdas de pipetagem, e obtenha o total de cada reagente.`)
};

const pt_pcr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escale uma master mix de PCR para qualquer número de reações. Defina os volumes por reação, o número de reações e um excedente para perdas de pipetagem, e obtenha o total de cada reagente.`)
};

const ja_pcr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCRマスターミックスを任意の反応数にスケーリングします。1反応あたりの試薬量、反応数、ピペッティング損失分のオーバーヘッジを設定すると、各試薬の総量が求められます。`)
};

const zh_pcr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将 PCR 混合液按任意反应数量放大。设置每反应用量、反应数量和移液损耗余量，即可得到每种试剂的总用量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_intro", locale)
	if (locale === "en") return en_pcr_intro(inputs)
	if (locale === "es") return es_pcr_intro(inputs)
	if (locale === "de") return de_pcr_intro(inputs)
	if (locale === "nl") return nl_pcr_intro(inputs)
	if (locale === "fr") return fr_pcr_intro(inputs)
	if (locale === "it") return it_pcr_intro(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_intro(inputs)
	if (locale === "pt") return pt_pcr_intro(inputs)
	if (locale === "ja") return ja_pcr_intro(inputs)
	return zh_pcr_intro(inputs)
};